import { Breadcrumb } from 'antd';
import {
  get,
  isArray,
  isEmpty,
  isNull,
  last,
  replace,
  reverse,
  values,
} from 'lodash';
import React from 'react';
import {
  getPostCategoryInThai,
  PostSubcategory,
} from '../../../common/helpers/domain/postCategories';
import { getProjectPagePath } from '../../../common/helpers/routing/urlGenerator';
import commonResource from '../../../locales/th/common.json';
import { BreadcrumbWrapper } from './ContentBreadcrumb.style';
import Link from 'next/link';
import { Post, PostProject } from '../../../queries/contentPage/postDetail';

const baseUrl = '/';

interface BreadcrumbItem {
  name: string | string[];
  link: string | null;
}

interface ContentBreadcrumbProps {
  post?: Post;
}

function getBreadcrumb(
  project: PostProject,
  postCategory: string,
): BreadcrumbItem[] {
  const objBreadcrumb: BreadcrumbItem[] = [{ name: 'Home', link: baseUrl }];
  if (!isEmpty(project.propertyType) && project.propertyType.length > 0) {
    objBreadcrumb.push({ name: project.propertyType, link: baseUrl });
  }

  if (
    !isEmpty(get(project, 'location.district')) &&
    project.location.district.length > 0
  ) {
    const newData = reverse(values(project.location.district));
    const lastData = last(newData) as unknown as {
      link: string;
      label: string;
    };
    const districtLink = replace(
      baseUrl + lastData.link.substring(1),
      /district/g,
      commonResource.location.district,
    );
    objBreadcrumb.push({ name: lastData.label, link: districtLink });
  }

  if (
    !isEmpty(get(project, 'location.zone')) &&
    project.location.zone.length > 0
  ) {
    const newData = reverse(values(project.location.zone));
    const lastData = last(newData) as unknown as {
      link: string;
      label: string;
    };
    const zoneLink = replace(
      baseUrl + lastData.link.substring(1),
      /zone/g,
      commonResource.location.zone,
    );
    objBreadcrumb.push({ name: lastData.label, link: zoneLink });
  }

  if (!isEmpty(project.name)) {
    objBreadcrumb.push({
      name: project.name,
      link: getProjectPagePath(project.link),
    });
  }

  if (!isNull(postCategory)) {
    objBreadcrumb.push({
      name: getPostCategoryInThai(postCategory as PostSubcategory),
      link: null,
    });
  }

  return objBreadcrumb;
}

const ContentBreadcrumb: React.FC<ContentBreadcrumbProps> = (props) => {
  const { post } = props;
  const { project, postCategory } = post;
  const listBreadcrumb = getBreadcrumb(project, postCategory);

  return (
    <BreadcrumbWrapper data-test={'content-breadcrumb'}>
      <Breadcrumb className="breadcrumb">
        {listBreadcrumb.map(function (v, k) {
          if (!isNull(v.link)) {
            if (isArray(v.name)) {
              const sum = v.name.length;
              return (
                <Breadcrumb.Item key={k} data-test={'breadcrumb-item-' + k}>
                  {v.name.map(function (data, index) {
                    return (
                      <Link
                        key={`${v.link}_${data}`}
                        href={v.link + data + '/'}
                        legacyBehavior
                      >
                        {data + (index + 1 < sum ? ', ' : '')}
                      </Link>
                    );
                  })}
                </Breadcrumb.Item>
              );
            }
            return (
              <Breadcrumb.Item key={k} data-test={'breadcrumb-item-' + k}>
                <a href={v.link}>{v.name}</a>
              </Breadcrumb.Item>
            );
          } else {
            return (
              <Breadcrumb.Item key={k} data-test={'breadcrumb-item-' + k}>
                {v.name}
              </Breadcrumb.Item>
            );
          }
        })}
      </Breadcrumb>
    </BreadcrumbWrapper>
  );
};

export default ContentBreadcrumb;
